module.exports = __webpack_public_path__ + "static/media/sakaneMabroukFV.e91fd899.jpg";